import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { AppLoginService } from '../../../app-login/app-login.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ManageProfileService } from '../manage-profile.service';
import { LocalService } from '@app/@core/services/local.service';
import { AlertService } from '@core/services/alert.service';
import { ChangeDetectorRef } from '@angular/core';
import { take, takeUntil } from 'rxjs';
import { AppConstants } from '@app/@core/entities/app-constants';
@Component({
  standalone: false,
  selector: 'app-update-contact',
  templateUrl: './update-contact.component.html',
  styleUrls: ['./update-contact.component.scss']
})
export class UpdateContactComponent implements OnInit, OnDestroy, AfterViewInit {
   showSecond = false;
  @ViewChild('otpFirst') otpFirstInput!: ElementRef;
  @ViewChild('firstFocusableElement') firstFocusableElement!: ElementRef;

  otp: string[] = ['', '', '', '', '', ''];
  timerActive = false;
  timeRemaining = 45;
  timerDisplay = '00:45';
  timerInterval: any = null;
  isResending = false;
  titleStr = 'Change Email Address';
  newEmail = '';
  oldEmail = '';
  type = 'email';
  invalidEmail = false;
  emailTooLong = false;
  oldPhone = '';
  newPhone = '';
  invalidPhone = false;
  paramEmail = '';
  person_id = 0;
  isMobile = false;
  resizeObservable$: Subscription | undefined;
  errorMessage: any = '';
  errorMessages: any = {};
  toastMessage: any = {};
  showToast: boolean = false;
  toastTitle: string = ''
  toastType = '';
  toastMessageText = '';
  toastTimer: any;
  genericMessage: any = {};
  placeholderMessage: any = {};
  emailTooltip = false;
  displayPhone = '';
  disableFlag = false;
  phoneEmpty: boolean = false;
  private readonly correctRecoveryOtp = '628170';
  showRecoveryOtpError = false;
  recoveryEmptyFieldsAfterBlur: boolean[] = new Array(6).fill(false);
  recoveryHadFocus = false;
  isVarificationSent: boolean = false;
  pntPhoneNo = '';
  pntRecoveryEmail = '';
  verifyUpdate: any = 'Verify and Update Email';
  emailLabel: any = 'New Email';
  sameEmail = false;
  isPrimaryAndRecoverySameEmail = false;
  sameNumber = false;
  fieldFocus = false;
  emailExist = false;
  recoveryAttempts = 0;
  phoneAttempts = 0; // Track phone OTP attempts
  maxAttempts = 5; // Default fallback - will be updated from API
  recoveryResendDisabledUntil: number | null = null; // timestamp until which resend is disabled
  resendCount = 0;
  maxResendCount = 7; // Default fallback - will be updated from API
  isBlocked = false;
  otpDigits: string[] = [];
  resendTimer = 60; // Default 60 seconds - will be updated from API
  otpLockoutDuration = 3; // Default 3 minutes - will be updated from API
  otpResendCooldown = 1; // Default 1 minute - will be updated from API
  otpResendLockoutDuration = 15; // Default 15 minutes - hardcoded lockout after max attempts
  formattedTime = '00:00';
  resendBlockedUntil: number | null = null; // timestamp until which resend is disabled
  resendBlockTimer: any = null;
  resendBlockTimeRemaining = 0;
  phoneNumberAlredyExist: boolean = false;
  emailAlredyExist: boolean = false;
  isCheckingEmail: boolean = false;
  isCheckingPhone: boolean = false;
  otpTouched = false;
  showOtpError = false;
  private destroy$ = new Subject<void>();
  hoverAnnouncement = ''; // For screen reader hover announcement

  constructor(
    private readonly router: Router,
    private readonly appLoginService: AppLoginService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<UpdateContactComponent>,
    private manageProfileService: ManageProfileService,
    private localstorage: LocalService,
    private alertService: AlertService,
    private el: ElementRef,
    private cdr: ChangeDetectorRef
  ) {}

  /**
   * Angular lifecycle hook. Initializes the modal and sets the data.
   */
  ngOnInit(): void {
    this.loadOtpValidationRules();
    this.el.nativeElement.focus();
    try{
      const errorMessageStr = this.localstorage.getItem('errorMessage');
      const toastMessageStr = this.localstorage.getItem('toastMessage');
      const genericMessageStr = this.localstorage.getItem('genericMessage');
      const placeholderMessageStr = this.localstorage.getItem('placeholderMessage');
      
      if(errorMessageStr){
        this.errorMessages = JSON.parse(errorMessageStr);
      }
      if(toastMessageStr){
        this.toastMessage = JSON.parse(toastMessageStr);
      }
      if(genericMessageStr){
        this.genericMessage = JSON.parse(genericMessageStr);
      }
      if(placeholderMessageStr){
        this.placeholderMessage = JSON.parse(placeholderMessageStr);
      }
    }catch(e){
      console.log('Error loading messages from localStorage:', e);
    }

    try{
      const isBlocked = this.localstorage.getItem('isEmailChangeBlocked').toString();
      const blockTime = new Date(this.localstorage.getItem('emailChangeBlockTime'));
      const currentTime = new Date();
      const diff =  Math.abs(currentTime.getTime() - blockTime.getTime());
      const fifteenMins = 15 * 60 * 1000; 

      if(diff < fifteenMins && isBlocked === 'true'){
        this.isBlocked = true;
      }else{
        this.isBlocked = false;
        this.localstorage.removeItem('isEmailChangeBlocked');
        this.localstorage.removeItem('emailChangeBlockTime');
      }
    }catch(e){
      console.log(e);
    }

    // Check for phone number change blocking
    try{
      const isPhoneBlocked = this.localstorage.getItem('isPhoneChangeBlocked').toString();
      const phoneBlockTime = new Date(this.localstorage.getItem('phoneChangeBlockTime'));
      const currentTime = new Date();
      const diff = Math.abs(currentTime.getTime() - phoneBlockTime.getTime());
      const fifteenMins = 15 * 60 * 1000; 

      if(diff < fifteenMins && isPhoneBlocked === 'true' && this.type === 'phoneNumber'){
        this.isBlocked = true;
      }else if(this.type === 'phoneNumber'){
        this.localstorage.removeItem('isPhoneChangeBlocked');
        this.localstorage.removeItem('phoneChangeBlockTime');
      }
    }catch(e){
      console.log(e);
    }

     // Migrate old generic keys to field-specific keys (backward compatibility)
    this.migrateOldResendData();
 
    // Check for resend blocking (field-specific)
    try{
      const resendCount = parseInt(this.localstorage.getItem(this.getResendCountKey()) || '0');
      const resendBlockTime = this.localstorage.getItem(this.getResendBlockTimeKey());
     
      if(resendBlockTime && resendCount >= this.maxResendCount){
        const blockTime = new Date(resendBlockTime);
        const currentTime = new Date();
        const diff = Math.abs(currentTime.getTime() - blockTime.getTime());
        const lockoutDurationMs = this.otpResendLockoutDuration * 60 * 1000;
 
        if(diff < lockoutDurationMs){
          // Only set shared properties for the CURRENT field type
          this.resendCount = resendCount;
          this.resendBlockedUntil = blockTime.getTime() + lockoutDurationMs;
          this.resendBlockTimeRemaining = this.getCurrentFieldRemainingTime();
          this.startResendBlockTimer();
        }else{
          // Block period expired, reset counters (field-specific)
          this.localstorage.removeItem(this.getResendCountKey());
          this.localstorage.removeItem(this.getResendBlockTimeKey());
          this.resendCount = 0;
          this.resendBlockTimeRemaining = 0;
        }
      }else if(resendCount < this.maxResendCount){
        // Only set for current field
        this.resendCount = resendCount;
        this.resendBlockTimeRemaining = 0;
      }else{
        // Initialize default values for current field
        this.resendCount = 0;
        this.resendBlockTimeRemaining = 0;
      }
    }catch(e){
      console.log(e);
    }

    this.type=this.data?.emailType || '';
    this.person_id = this.data.user_id;
    if(this.type==='primaryEmail'){
      this.titleStr='Change Primary Email Address';
      this.oldEmail=this.data.currentEmail.toString();
      this.newEmail = this.data.currentEmail.toString();
      this.paramEmail = this.data.recoveryEmail || '';
      this.pntPhoneNo = this.data.currentNumber || '';
      this.verifyUpdate = 'Verify and Update Email';
      this.emailLabel = 'New Primary Email';
    } else if(this.type==='recoveryEmail'){
      this.titleStr='Change Recovery Email Address';
      this.oldEmail=this.data.currentEmail.toString();
      this.newEmail = this.data.currentEmail.toString();
      this.paramEmail = this.data.primaryEmail || '';
      this.pntPhoneNo = this.data.currentNumber || '';
      this.verifyUpdate = 'Verify and Update Recovery Email';
      this.emailLabel = 'New Recovery Email';
    } else if(this.type==='phoneNumber' || this.type==='altPhoneNumber'){
      this.titleStr = this.type === 'altPhoneNumber' ? 'Change Alternate Phone Number' : 'Change Phone Number';
      let currentNumber = this.data.currentNumber.toString();
      
      // Remove all non-digit characters
      const digits = currentNumber.replace(/\D/g, '');
      
      // Handle 11-digit numbers (with country code)
      if (digits.length === 11 && digits.startsWith('1')) {
        this.oldPhone = `+1 (${digits.substring(1, 4)}) ${digits.substring(4, 7)}-${digits.substring(7)}`;
        this.newPhone = `+1 (${digits.substring(1, 4)}) ${digits.substring(4, 7)}-${digits.substring(7)}`;
      } 
      // Handle 10-digit numbers (without country code)
      else if (digits.length === 10) {
        this.oldPhone = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
        this.newPhone = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      }
      // Fallback for unexpected formats
      else {
        this.oldPhone = currentNumber;
        this.newPhone = currentNumber;
      }
      
      this.displayPhone = this.maskPhoneNumber(this.newPhone);
      this.paramEmail = this.data.primaryEmail || '';
      this.pntRecoveryEmail = this.data.recoveryEmail || '';
      this.verifyUpdate = this.type === 'altPhoneNumber' ? 'Verify and Update Alternate Phone Number' : 'Verify and Update Phone Number';
    }
  }

  /**
   * Angular lifecycle hook. Set focus to first interactive element after view init.
   */
  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.firstFocusableElement?.nativeElement) {
        this.firstFocusableElement.nativeElement.focus();
      }
    }, 0);
  }
  
  /**
   * Checks whether the email is valid or invalid, and sets error flags accordingly.
   * @param email The email address to validate.
   */
  validateEmail(email: string) {
    this.sameEmail = false;
    this.emailExist = false;
    this.invalidPhone = false;
    this.isPrimaryAndRecoverySameEmail = false;
    this.invalidEmail = false;
    this.emailTooLong = false;
    this.emailAlredyExist = false;
    
    if(email==='' || email == undefined){
      this.sameEmail = false;
      return;
    }

    // Check email length - must be <= 255 characters
    if(email.length > 255) {
      this.emailTooLong = true;
      this.cdr.detectChanges();
      return;
    }

    if(email === this.oldEmail){
      this.sameEmail = true;
      const msg = this.toastMessage['T0032'];
      this.showFailureToastMsg(msg);
      return;
    }

    if(email === this.paramEmail){
      this.isPrimaryAndRecoverySameEmail = true;
      return;
    }

    // Enhanced email regex pattern to match user@example.com format
    // - Local part: alphanumeric, dots, underscores, percent, plus, and hyphens
    // - Domain part: alphanumeric, dots, and hyphens
    // - Domain extension: 2-10 letters only
    const emailPattern = /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;
    
    // Split email into parts for additional validation
    const emailParts = email.split('@');
    
    // Check if email has exactly one @ symbol
    if (emailParts.length !== 2) {
      this.invalidEmail = true;
      this.cdr.detectChanges();
      return;
    }
    
    const localPart = emailParts[0];
    const domainPart = emailParts[1];
    
    // Check if local part and domain part are not empty
    if (!localPart || !domainPart || localPart.length === 0 || domainPart.length === 0) {
      this.invalidEmail = true;
      this.cdr.detectChanges();
      return;
    }
    
    // Check local part length (should be reasonable, typically max 64 chars per RFC)
    if (localPart.length > 64) {
      this.invalidEmail = true;
      this.cdr.detectChanges();
      return;
    }
    
    // Check if domain has at least one dot and proper structure
    const domainParts = domainPart.split('.');
    if (domainParts.length < 2) {
      this.invalidEmail = true;
      this.cdr.detectChanges();
      return;
    }
    
    // Check if domain parts are not empty
    if (domainParts.some(part => part.length === 0)) {
      this.invalidEmail = true;
      this.cdr.detectChanges();
      return;
    }
    
    // Check if domain doesn't start or end with dot or hyphen
    if (domainPart.startsWith('.') || domainPart.endsWith('.') || 
        domainPart.startsWith('-') || domainPart.endsWith('-')) {
      this.invalidEmail = true;
      this.cdr.detectChanges();
      return;
    }
    
    // Check if local part doesn't start or end with dot or have consecutive dots
    if (localPart.startsWith('.') || localPart.endsWith('.') || localPart.includes('..')) {
      this.invalidEmail = true;
      this.cdr.detectChanges();
      return;
    }
    
    // Check if domain doesn't have consecutive dots
    if (domainPart.includes('..')) {
      this.invalidEmail = true;
      this.cdr.detectChanges();
      return;
    }
    
    const result = emailPattern.test(email);
    
    if(result){
      this.invalidEmail = false;
      this.isCheckingEmail = true;
      this.manageProfileService.checkEmailExists(this.newEmail).pipe(take(1), takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          this.isCheckingEmail = false;
          if (response.data.exists === true) {
            //T0003 - Email already exists
            const msg = this.toastMessage['T0032'];
            this.sameEmail = true;
            this.emailAlredyExist = true;
            //this.alertService.error(msg);
            this.showFailureToastMsg(msg);
          }else{
            this.emailExist = false;
          } 
        },
        error: () => {
          //failure case
          const msg = this.toastMessage['T0032'];
          this.showFailureToastMsg(msg);
          this.sameEmail = true;
          this.isCheckingEmail = false;
        }
      });
    }else{
      this.invalidEmail = true;
    }
    
    this.cdr.detectChanges(); // Ensure view updates
  }

  /**
   * Checks whether the phone number is valid or invalid, and sets error flags accordingly.
   * @param phone The phone number to validate.
   */
  validatePhone(target, phone: string, inputType?: string) {
    this.invalidPhone = false;
    this.sameNumber = false;
    this.phoneNumberAlredyExist = false;
 
    if(phone === this.oldPhone){
      this.sameNumber = true;
      const msg = this.toastMessage['T0033'];
      this.showFailureToastMsg(msg);
      return;
    }

    target.setAttribute('maxLength', '17');

    const isDeleting = !!inputType && inputType.includes('delete');

    let formattedPhone: string;
    if (isDeleting) {
      // Allow deletion naturally; don't reformat so backspace works character by character
      formattedPhone = phone;
    } else {
      // Ensure +1 prefix then format via maskPhoneNumber
      let val = phone;
      if (!val.startsWith('+1')) {
        val = '+1 ' + val.replace(/^\+/, '');
      }
      formattedPhone = this.maskPhoneNumber(val);
    }

    this.displayPhone = formattedPhone;
    target.value = formattedPhone;
    this.newPhone = formattedPhone;

    if (!formattedPhone || /^\+1[\s]*$/.test(formattedPhone)) {
      this.phoneEmpty = true;
      this.invalidPhone = false;
      this.cdr.detectChanges();
      return;
    } else {
      this.phoneEmpty = false;
    }
    // Validate full "+1 (XXX) XXX-XXXX" format
    const phonePattern = /^\+1\s\(\d{3}\)\s\d{3}-\d{4}$/;
    const result = phonePattern.test(formattedPhone);
    if(result){
      this.invalidPhone = false;
      this.isCheckingPhone = true;
      const phoneToCheck = this.cleanPhoneNumber(this.newPhone);
      this.manageProfileService.checkPhoneExists(phoneToCheck).pipe(take(1), takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          this.isCheckingPhone = false;
          if (response.data.exists === true) {
            this.sameNumber = true;
            const msg = this.toastMessage['T0033'];
            this.showFailureToastMsg(msg);
            this.phoneNumberAlredyExist = true;
          } 
        },
        error: () => {
          //failure case
          const msg = this.toastMessage['T0004'];
          this.showFailureToastMsg(msg);
          this.isCheckingPhone = false;
        }
      });
    }else{
      this.invalidPhone = true;
    }

    this.cdr.detectChanges(); // Ensure view updates
  }

  /**
   * Unified HostListener for all input keydown events
   */
  @HostListener('keydown', ['$event'])
  onUnifiedKeydown(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const fieldType = this.getFieldType(target);
    
    if (!fieldType) return;
    
    const config = this.fieldConfigs[fieldType];
    if (!this.isKeyAllowed(event.key, config)) {
      event.preventDefault();
    }
  }

  /**
   * Unified HostListener for all input paste events
   */
  @HostListener('paste', ['$event'])
  onUnifiedPaste(event: ClipboardEvent): void {
    const target = event.target as HTMLInputElement;
    const fieldType = this.getFieldType(target);
    
    if (!fieldType) return;
    
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const config = this.fieldConfigs[fieldType];
    
    if (config.pasteValidator.test(pastedData)) {
      // Temporarily clear focus state to prevent empty field errors during paste
      const originalFocusState = this.fieldFocus;
      this.fieldFocus = false;
      
      // Update the corresponding NgModel property based on field type
      if (fieldType === 'email') {
        this.newEmail = pastedData;
        target.value = pastedData;
        // Trigger validation
        config.inputHandler(target, pastedData);
      } else if (fieldType === 'phone') {
        let pasteVal = pastedData;
        if (!pasteVal.startsWith('+1')) {
          pasteVal = '+1 ' + pasteVal.replace(/^\+/, '');
        }
        const formattedPhone = this.maskPhoneNumber(pasteVal);
        this.displayPhone = formattedPhone;
        target.value = formattedPhone;
        this.newPhone = formattedPhone;
        this.phoneEmpty = !formattedPhone || /^\+1[\s]*$/.test(formattedPhone);
        config.inputHandler(target, formattedPhone);
      } else if (fieldType === 'otp') {
        const index = this.getOtpIndex(target);
        if (index !== undefined && pastedData.length === 1) {
          this.otp[index] = pastedData;
          target.value = pastedData;
          // Trigger validation
          config.inputHandler(target, pastedData, index);
        }
      }
      
      // Restore focus state after a brief delay to allow validation to complete
      setTimeout(() => {
        this.fieldFocus = originalFocusState;
        this.cdr.detectChanges();
      }, 10);
    }
  }

  /**
   * Unified HostListener for all input events
   */
  @HostListener('input', ['$event'])
  onUnifiedInput(event: InputEvent): void {
    const target = event.target as HTMLInputElement;
    const fieldType = this.getFieldType(target);
    
    if (!fieldType) return;
    
    const config = this.fieldConfigs[fieldType];
    config.inputHandler(target, target.value, this.getOtpIndex(target), event);
  }

  /**
   * Email field focus handler
   */
  onEmailFocus(): void {
    this.fieldFocus = true;
  }

  /**
   * Phone field focus handler
   */
  onPhoneFocus(): void {
    this.fieldFocus = true;
  }

  /**
   * Phone field blur handler
   */
  onPhoneBlur(): void {
    // Treat empty, partial-only (+1 with no national digits), or artifact values as empty
    const val = this.displayPhone ?? '';
    if (!val || val.trim() === '' || val === '(' || /^\+1[\s]*$/.test(val)) {
      this.phoneEmpty = true;
      this.displayPhone = '';
      this.newPhone = '';
    }
  }

  /**
   * OTP field focus handler
   */
  onOtpFocus(): void {
    this.fieldFocus = true;
    this.otpTouched = true;
  }


  /**
   * Determines the field type based on target element
   */
  private getFieldType(target: HTMLInputElement): string | null {
    if (target.id === 'inputfield_updateContact_phoneNumber') return 'phone';
    if (target.id === 'inputfield_updateContact_email') return 'email';
    if (target.classList.contains('otp-input')) return 'otp';
    return null;
  }

  /**
   * Gets OTP input index from data attribute
   */
  private getOtpIndex(target: HTMLInputElement): number | undefined {
    return target.dataset['index'] ? parseInt(target.dataset['index'], 10) : undefined;
  }

  /**
   * Checks if a key is allowed based on field configuration
   */
  private isKeyAllowed(key: string, config: any): boolean {
    const isNumber = /^\d$/.test(key);
    const isLetter = /^[a-zA-Z]$/.test(key);
    const isAllowedKey = config.allowedKeys.includes(key);
    const isSpecialChar = config.allowSpecialChars.includes(key);
    
    // Check if letters are allowed for this field type
    const lettersAllowed = config.allowLetters !== false;
    
    return isAllowedKey || 
           (isNumber && config.allowNumbers) || 
           (isLetter && lettersAllowed) || 
           isSpecialChar;
  }

  /**
   * Formats the newPhone input to mask as +1 (XXX) XXX-XXXX or (XXX) XXX-XXXX.
   * @param event The input event from the phone number field.
   */
  formatNewPhoneNumber(event: any) {
    let input = event.target.value;
    // Block alphabetic input
    if (/[a-zA-Z]/.test(input)) {
      input = input.replace(/[a-zA-Z]/g, '');
    }
    // Allow empty value
    if (!input) {
      this.newPhone = '';
      event.target.value = '';
      return;
    }
    // If starts with '+1', enforce '+1 (XXX) XXX-XXXX' format
    if (input.startsWith('+1')) {
      // Only insert space after '+1' if user is typing forward (not deleting)
      if (input.length > 2 && input[2] !== ' ') {
        if (event.inputType !== 'deleteContentBackward') {
          input = '+1 ' + input.slice(2);
        }
      }
      const numberPart = input.startsWith('+1 ') ? input.slice(3) : input.slice(2);
      let digits = numberPart.replace(/\D/g, '');
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      const finalValue = input.startsWith('+1 ') ? '+1 ' + formatted : '+1' + formatted;
      this.newPhone = finalValue;
      event.target.value = finalValue;
      return;
    }
    // If starts with '(', enforce '(XXX) XXX-XXXX' format
    if (input.startsWith('(')) {
      let digits = input.replace(/\D/g, '');
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      this.newPhone = formatted;
      event.target.value = formatted;
      return;
    }
    // If only digits, format as '(XXX) XXX-XXXX'
    if (/^\d+$/.test(input)) {
      const digits = input.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      this.newPhone = formatted;
      event.target.value = formatted;
      return;
    }
    // Otherwise, just assign the input
    this.newPhone = input;
    event.target.value = input;
  }

  /**
   * Sets the focus on the first OTP input field.
   */
  private focusFirstInput(): void {
    setTimeout(() => {
      if (this.otpFirstInput?.nativeElement) {
        this.otpFirstInput.nativeElement.focus();
      }
    }, 0);
  }

  /**
   * Starts the OTP timer and updates the timer display.
   */
  startTimer(): void {
    this.clearTimer();
    this.timerActive = true;
    this.timeRemaining = this.resendTimer;
    this.updateTimerDisplay();
    
    this.timerInterval = setInterval(() => {
      this.timeRemaining--;
      this.updateTimerDisplay();
      
      if (this.timeRemaining <= 0) {
        this.clearTimer();
        this.timerActive = false;
        this.timeRemaining = 0; // Ensure it's exactly 0
        this.updateTimerDisplay(); // Update display to show 00:00
        this.cdr.detectChanges(); // Trigger change detection to update UI
        // this.errorMessage = 'OTP expired. Please request a new verification code.';
      }
    }, 1000);
  }

  /**
   * Clears the OTP timer if it is running.
   */
  clearTimer(): void {
    if (this.timerInterval !== null) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  /**
   * Updates the timer display in MM:SS format based on timeRemaining.
   */
  updateTimerDisplay(): void {
    const minutes = Math.floor(this.timeRemaining / 60);
    const seconds = this.timeRemaining % 60;
    this.timerDisplay = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  
  /**
   * Starts the resend block timer for 15 minutes (field-specific)
   */
  startResendBlockTimer(): void {
    // Use field-specific timing instead of shared property
    const updateTimer = () => {
      const remainingTime = this.getCurrentFieldRemainingTime();
       
      if (remainingTime > 0) {
        this.resendBlockTimeRemaining = remainingTime;
        this.resendBlockTimer = setTimeout(updateTimer, 1000);
      } else {
        // Timer expired, reset everything for current field
        this.resendBlockTimeRemaining = 0;
        this.resendCount = 0;
        this.resendBlockedUntil = null;
        this.localstorage.removeItem(this.getResendCountKey());
        this.localstorage.removeItem(this.getResendBlockTimeKey());
        if (this.resendBlockTimer) {
          clearTimeout(this.resendBlockTimer);
          this.resendBlockTimer = null;
        }
      }
    };
    updateTimer();
  }
 
  /**
   * Clears the resend block timer
   */
  clearResendBlockTimer(): void {
    if (this.resendBlockTimer) {
      clearTimeout(this.resendBlockTimer);
      this.resendBlockTimer = null;
    }
  }
 
  /**
   * Formats time remaining in MM:SS format for resend block timer
   */
  getResendBlockTimeDisplay(): string {
    const minutes = Math.floor(this.resendBlockTimeRemaining / 60);
    const seconds = this.resendBlockTimeRemaining % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  /**
   * Handles changes in any of the OTP input fields, moving focus as needed.
   * @param index The index of the OTP input field.
   * @param event The input event.
   */
  onOtpChange(index: number, event: Event): void {
    const input = event.target;
    
    if (!(input instanceof HTMLInputElement)) {
      return;
    }
    
    if (input.value) {
      const numericValue = input.value.replace(/\D/g, '');
      if (input.value !== numericValue) {
        input.value = numericValue;
      }
      this.otp[index] = numericValue;
      
      // Clear error message when user starts typing
      if (this.showOtpError) {
        this.showOtpError = false;
        this.errorMessage = '';
      }
    } else {
      // Value was deleted/cleared
      this.otp[index] = '';
      
      // Check if all OTP fields are now empty and user has touched the fields
      if (this.otpTouched && this.otp.join('').length === 0) {
        this.showOtpErrorMessage();
      }
    }
    
    if (input.value && index < 5) {
      const nextElement = input.parentElement?.children?.[index + 1];
      if (nextElement instanceof HTMLInputElement) {
        nextElement.focus();
      }
    }
    
    if (input.value === '' && index > 0) {
      const prevElement = input.parentElement?.children?.[index - 1];
      if (prevElement instanceof HTMLInputElement) {
        prevElement.focus();
      }
    }
  }

  /**
   * Shows the appropriate OTP error message based on type
   */
  private showOtpErrorMessage(): void {
    this.showOtpError = true;
    
    if (this.type === 'primaryEmail') {
      this.errorMessage = this.errorMessages['M0045'];
    } else if (this.type === 'recoveryEmail') {
      this.errorMessage = this.errorMessages['M0046'];
    } else if (this.type === 'phoneNumber') {
      this.errorMessage = this.errorMessages['M0038'];
    }
  }

  resendOtp(): void {
    // Check if already blocked using field-specific checks
    if (this.isCurrentFieldMaxResendsReached() || this.getCurrentFieldRemainingTime() > 0) {
      return;
    }

    this.otp = ['', '', '', '', '', ''];
    this.isResending = true;
    
    // Reset OTP validation flags
    this.otpTouched = false;
    this.showOtpError = false;
    this.errorMessage = '';
    
    // Get current field's resend count and increment it
    const currentCount = this.getCurrentFieldResendCount();
    const newCount = currentCount + 1;
    
    // Store updated resend count in localStorage (field-specific)
    this.localstorage.setItem(this.getResendCountKey(), newCount.toString());
    
    // Update the shared property for this session
    this.resendCount = newCount;
    
    // Check if this resend attempt should trigger blocking
    if (newCount >= this.maxResendCount) {
      const blockTime = new Date();
      this.localstorage.setItem(this.getResendBlockTimeKey(), blockTime.toISOString());
      this.resendBlockedUntil = blockTime.getTime() + (this.otpResendLockoutDuration * 60 * 1000);
      this.resendBlockTimeRemaining = this.getCurrentFieldRemainingTime();
      this.startResendBlockTimer();
      return;
    }
   
    this.disableFlag = true;
    this.resendOTPMail();
    this.startTimer();
    this.focusFirstInput();
  }

  /**
   * Method invoked on Cancel button click in the modal window
   */
  cancel(): void {
    this.dialogRef.close({ response: 'cancel' });
  }
  
  /**
   * Restricts OTP input fields to only accept numeric values.
   * @param event The keyboard event.
   * @returns True if the input is numeric or a control key, false otherwise.
   */
  onlyNumeric(event: KeyboardEvent): boolean {
    // Use event.key instead of deprecated keyCode
    const key = event.key;
    const isNumber = /^\d$/.test(key);
    const isControlKey = event.ctrlKey || event.altKey || 
                         key === 'Tab' || 
                         key === 'Delete' || 
                         key === 'Backspace' ||
                         key === 'ArrowLeft' || 
                         key === 'ArrowRight' ||
                         key === 'Home' ||
                         key === 'End';
    
    if (!isNumber && !isControlKey) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  /**
   * Closes the dialog with a cancel response (triggered by close icon).
   */
  onClose(){
    this.dialogRef.close({ response: 'cancel' });
  }

  /**
   * Updates the newPhone and displayPhone values.
   * @param val The new phone value.
   */
  updateNewPh(val){
    this.newPhone = val;
    this.displayPhone = val;
    console.log(val);
  }

  /**
   * Resets email validation flags
   */
  resetEmailValidationFlags(): void {
    this.invalidEmail = false;
    this.emailTooLong = false;
    this.sameEmail = false;
    this.isPrimaryAndRecoverySameEmail = false;
    this.emailExist = false;
  }

  /**
   * Resets resend blocking when starting fresh (field-specific)
   */
  resetResendBlocking(): void {
    this.resendCount = 0;
    this.resendBlockedUntil = null;
    this.resendBlockTimeRemaining = 0;
    this.clearResendBlockTimer();
    this.localstorage.removeItem(this.getResendCountKey());
    this.localstorage.removeItem(this.getResendBlockTimeKey());
    
    // Reset verification attempts for current field type
    if(this.type === 'phoneNumber') {
      this.phoneAttempts = 0;
      this.localstorage.removeItem('isPhoneChangeBlocked');
      this.localstorage.removeItem('phoneChangeBlockTime');
    } else {
      this.recoveryAttempts = 0;
      this.localstorage.removeItem('isEmailChangeBlocked');
      this.localstorage.removeItem('emailChangeBlockTime');
    }
  }
 

  sendVerification(){
    // Check if current field is blocked (field-specific blocking)
    const isCurrentFieldBlocked = this.isCurrentFieldBlocked();
    const currentFieldRemainingTime = this.getCurrentFieldRemainingTime();
   
    if (isCurrentFieldBlocked || currentFieldRemainingTime > 0) {
      let msg = this.toastMessage['T0029'];
      const minutes = Math.floor(currentFieldRemainingTime / 60);
      const seconds = currentFieldRemainingTime % 60;
      const remainingTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      msg = msg.replace('{N}', remainingTime);
      this.showFailureToastMsg(msg);
 
      return;
    }
 
    // Check for old email-specific blocking (backward compatibility)
    if (this.isBlocked) {
      let msg = this.toastMessage['T0029'];
      this.showFailureToastMsg(msg);
      return;
    }
 
    // Initialize resend count when first sending verification (field-specific)
    if (this.resendCount === 0) {
      this.resendCount = 1;
      this.localstorage.setItem(this.getResendCountKey(), '1');
    }
 
    //Validate email format before sending verification
    if(this.type==='primaryEmail' || this.type === 'recoveryEmail'){
      // Perform final validation check
      if (this.invalidEmail || this.emailTooLong || this.sameEmail || this.isPrimaryAndRecoverySameEmail) {
        // Don't proceed if validation fails
        return;
      }
     
      const msg = this.toastMessage['T0024'];
      this.showSuccessToastMsg(msg);
      this.disableFlag = true;
      this.showSecond=true;
      this.sendOTPMail();
      this.focusFirstInput();
      this.isVarificationSent = true;
      // Reset OTP validation flags
      this.otpTouched = false;
      this.showOtpError = false;
      this.errorMessage = '';
    }else{
      const msg = this.toastMessage['T0025'];
      this.showSuccessToastMsg(msg);
      this.disableFlag = true;
      this.showSecond=true;
      this.focusFirstInput();
      // Reset OTP validation flags
      this.otpTouched = false;
      this.showOtpError = false;
      this.errorMessage = '';
      this.isVarificationSent = true;
    }
   
  }

  /**
   * Method to verify the OTP entered by the user and update the value in the API
   * @returns 
   */
  verifyOtp(): void {
    const otpValue = this.otp.join('');
    
    if (otpValue.length < 6) {
      this.errorMessage = this.errorMessages['M0038'];
      return;
    }

    // // Hardcoded OTP check for phone number verification
    // if (this.type !== 'primaryEmail' && this.type !== 'recoveryEmail') {
    //   if (otpValue !== this.correctOtp) {
    //     this.toastMessageText = 'The code you entered is incorrect. Try again or resend OTP.';
    //     this.toastType = 'error';
    //     this.showToast = true;
    //     this.setShortToastTimer();
    //     return;
    //   }
    // }

    this.errorMessage = '';
    this.clearTimer();
    
    // let msg = 'A verification code has been sent to your new email address. Please check your inbox and spam folder.';
    // try{
    //   msg = this.toastMessage['T0024'];
    // }catch(e){}
    //code to invoke service for verification and update
    const cleanedNumber = this.cleanPhoneNumber(this.newPhone);
    if(this.type==='primaryEmail'){
      //this.showSuccessToastMsg(msg);
      this.manageProfileService.verifyAndChangePrimaryEmail(this.paramEmail, this.newEmail, this.person_id, otpValue).pipe(take(1), takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          console.log('Primary email changed successfully', response);
            if (
        response.status === 'success' &&
        response.data &&
        response.data.success === false &&
        response.data.message === 'Invalid OTP. Please try again.'
      ) {
            this.recoveryAttempts++;
          // Handle API response indicating incorrect OTP
            this.showOtpErrorToast(this.recoveryAttempts);
            if(this.recoveryAttempts >= this.maxAttempts){
              this.isBlocked = true;
              this.localstorage.setItem('isEmailChangeBlocked', 'true');
              this.localstorage.setItem('emailChangeBlockTime', Date.now().toString());
              
              // Clear OTP input fields when blocked
              this.otp = ['', '', '', '', '', ''];
              
              // Set resend count to max to trigger 15-minute block
              const blockTime = new Date();
              this.localstorage.setItem(this.getResendCountKey(), this.maxResendCount.toString());
              this.localstorage.setItem(this.getResendBlockTimeKey(), blockTime.toISOString());
              this.resendBlockedUntil = blockTime.getTime() + (this.otpResendLockoutDuration * 60 * 1000);
              this.resendBlockTimeRemaining = this.getCurrentFieldRemainingTime();
              this.startResendBlockTimer();
            }
          } else if (response.data && response.data.success) {
            // OTP is correct
            console.log("Mail updated Successfully");
            sessionStorage.setItem('email', this.newEmail);
            this.syncEmailToAzure(this.oldEmail, this.newEmail);
            this.sendMailUpdateNotification('primary');
            this.dialogRef.close({ response: 'success' , type: this.type, newEmail: this.newEmail, newPhone: cleanedNumber });
          } else {
            // Fallback for any other error
            this.clearTimer();
            this.timerActive = false;
            const msg = response?.data?.message || 'Failed to change primary email. Please try again.';
            this.showFailureToastMsg(msg);
          }
        },
        error: (error) => {
          console.error('Error changing primary email', error);
          const msg = error?.error?.message || 'Failed to change '+this.type+' email. Please try again.';
          this.showFailureToastMsg(msg);
        }
      });
    } else if(this.type==='recoveryEmail'){
      // this.showSuccessToastMsg(msg);
      this.manageProfileService.verifyAndChangeRecoveryEmail(this.paramEmail, this.newEmail, this.person_id, otpValue).pipe(take(1), takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          console.log('Recovery email changed successfully', response);
            if (
        response.status === 'success' &&
        response.data &&
        response.data.success === false &&
        response.data.message === 'Invalid OTP. Please try again.'
      ) {
          this.recoveryAttempts++;
        // Handle API response indicating incorrect OTP
          this.showOtpErrorToast(this.recoveryAttempts);
          if(this.recoveryAttempts >= this.maxAttempts){
            this.isBlocked = true;
            this.localstorage.setItem('isEmailChangeBlocked', 'true');
            this.localstorage.setItem('emailChangeBlockTime', Date.now().toString());
            
            // Clear OTP input fields when blocked
            this.otp = ['', '', '', '', '', ''];
            
            // Set resend count to max to trigger 15-minute block
            const blockTime = new Date();
            this.localstorage.setItem(this.getResendCountKey(), this.maxResendCount.toString());
            this.localstorage.setItem(this.getResendBlockTimeKey(), blockTime.toISOString());
            this.resendBlockedUntil = blockTime.getTime() + (this.otpResendLockoutDuration * 60 * 1000);
            this.resendBlockTimeRemaining = this.getCurrentFieldRemainingTime();
            this.startResendBlockTimer();
          }
        } else if (response.data && response.data.success) {
            // OTP is correct
            this.sendMailUpdateNotification('recovery');
            this.dialogRef.close({ response: 'success' , type: this.type, newEmail: this.newEmail, newPhone: cleanedNumber });
          } else {
            // Fallback for any other error
            const msg = response?.data?.message || 'Failed to change recovery email. Please try again.';
            this.showFailureToastMsg(msg);
            this.clearTimer();
            this.timerActive = false;
          }
        },
        error: (error) => {
          const msg = error?.error?.message || 'Failed to change '+this.type+' email. Please try again.';
          this.showFailureToastMsg(msg);
        }
      });
    } else if(this.type === 'phoneNumber' || this.type === 'altPhoneNumber'){
      if(otpValue === this.correctRecoveryOtp){
        const updateObservable = this.type === 'altPhoneNumber' 
          ? this.manageProfileService.verifyAndChangeAlternatePhoneNumber(cleanedNumber, this.person_id, otpValue)
          : this.manageProfileService.verifyAndChangePhoneNumber(cleanedNumber, this.person_id, otpValue);
          
        updateObservable.pipe(take(1), takeUntil(this.destroy$)).subscribe({
          next: (response) => {
	          if(response.data && response.data.success){
	            // Since the email is being sent successfully, treat any non-error response as success
		          console.log(this.type + ' update email sent successfully');
              // Reset phone attempts on successful verification
              this.phoneAttempts = 0;
              this.localstorage.removeItem('isPhoneChangeBlocked');
              this.localstorage.removeItem('phoneChangeBlockTime');
              this.sendPhoneNumberUpdateNotification(this.type === 'altPhoneNumber' ? 'altPhone' : 'phone');
		          // this.showSuccessToastMsg('Phone number updated successfully.');
		          this.dialogRef.close({ response: 'success' , type: this.type, newEmail: this.newEmail, newPhone: cleanedNumber });
	          }else{
		          this.clearTimer();
		          this.timerActive = false;
              const msg = response.message || 'Failed to change Phone number. Please try again.';
              this.showFailureToastMsg(msg);
	          }
         },
	       error: (error) => {
	          console.error('Error changing phone number', error);
	          this.clearTimer();
            this.timerActive = false;
            const msg = error?.error?.message || 'Failed to change phone number. Please try again.';
            this.showFailureToastMsg(msg);
	        }
        });
      } else {
        // Handle incorrect phone OTP - same logic as email fields
        this.phoneAttempts++;
        this.showOtpErrorToast(this.phoneAttempts);
        if(this.phoneAttempts >= this.maxAttempts){
          this.isBlocked = true;
          // Use field-specific blocking keys like the resend logic
          this.localstorage.setItem('isPhoneChangeBlocked', 'true');
          this.localstorage.setItem('phoneChangeBlockTime', Date.now().toString());
          
          // Clear OTP input fields when blocked
          this.otp = ['', '', '', '', '', ''];
          
          // Set resend count to max to trigger 15-minute block
          const blockTime = new Date();
          this.localstorage.setItem(this.getResendCountKey(), this.maxResendCount.toString());
          this.localstorage.setItem(this.getResendBlockTimeKey(), blockTime.toISOString());
          this.resendBlockedUntil = blockTime.getTime() + (this.otpResendLockoutDuration * 60 * 1000);
          this.resendBlockTimeRemaining = this.getCurrentFieldRemainingTime();
          this.startResendBlockTimer();
        }
      }
    }
  }

  /**
   * Masks the phone number to the expected format +1 (XXX) XXX-XXXX / (XXX) XXX-XXXX.
   * @param phoneNumber The phone number to mask.
   * @returns The masked phone number string.
   */
  maskPhoneNumber(input) {
    if (!input) return '';
    // Block alphabetic input
    input = input.replace(/[a-zA-Z]/g, '');
    // If starts with '+1', enforce '+1 (XXX) XXX-XXXX' format
    if (input.startsWith('+1')) {
      if (input.length > 2 && input[2] !== ' ') {
        input = '+1 ' + input.slice(2);
      }
      let numberPart = input.startsWith('+1 ') ? input.slice(3) : input.slice(2);
      let digits = numberPart.replace(/\D/g, '');
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return input.startsWith('+1 ') ? '+1 ' + formatted : '+1' + formatted;
    }
    // If starts with '(', enforce '(XXX) XXX-XXXX' format
    if (input.startsWith('(')) {
      let digits = input.replace(/\D/g, '');
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return formatted;
    }
    // If only digits, format as '(XXX) XXX-XXXX'
    if (/^\d+$/.test(input)) {
      let digits = input.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return formatted;
    }
    // Allow '+', '+1', '+1 ' as valid prefixes
    if (input === '+' || input === '+1' || input === '+1 ') {
      return input;
    }
    // For any other input, clear the field
    return '';
  }

  /**
   * Sends an OTP to the user's new email or phone number.
   */
  sendOTPMail(){
    const phoneToSend = this.type === 'phoneNumber' ? this.cleanPhoneNumber(this.newPhone) : this.newPhone;
    this.manageProfileService.sendChangeContactOTP(this.type, this.newEmail, phoneToSend, this.person_id).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        console.log('OTP sent successfully', response);
      },
      error: (error) => {
        console.error('Error sending OTP', error);
      }
    });
  }

  /**
   * Resends the OTP to the user's new email or phone number.
   */
   resendOTPMail(){
    const phoneToSend = this.type === 'phoneNumber' ? this.cleanPhoneNumber(this.newPhone) : this.newPhone;
    this.manageProfileService.resendChangeContactOTP(this.type, this.newEmail, phoneToSend, this.person_id).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if(response.status === 'success'){
          // Show different message based on type (phone vs email)
          let msg = '';
          if(this.type === 'phoneNumber'){
            msg = this.toastMessage['T0025'];
          } else {
            msg = this.toastMessage['T0024'];
          }
          this.showSuccessToastMsg(msg);
          
        }
      },
      error: (error) => {
        console.error('Error sending OTP', error);
      }
    });
  }
  /**
   * Closes the current toast message.
   */
  closeToast() {
    this.showToast = false;
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }

  /**
   * Closes the toast message with the given element ID.
   * @param id The element ID of the toast to close.
   */
  closeToastMsg(id: string){
    const element = document.getElementById(id);
    if(element){
      element.parentElement.removeChild(element);
    }
  }

  /**
   * Displays a toast message for OTP errors based on the number of attempts.
   * @param attempts The number of failed OTP attempts.
   */
  showOtpErrorToast(attempts: number) {
    let toastMessage = '';
    
    const remainingAttempts = this.maxAttempts - attempts;
    
    if (attempts >= this.maxAttempts) {
      // Lockout message with dynamic duration
      toastMessage = AppConstants.verificationLocked.replace('{minutes}', this.otpResendLockoutDuration.toString());
    } else if (remainingAttempts > 0) {
      // Show remaining attempts dynamically
      toastMessage = AppConstants.incorrectAttempt.replace('{remainingAttempts}', remainingAttempts.toString());
    } else {
      toastMessage = this.toastMessage['T0005'];
    }
    this.showFailureToastMsg(toastMessage);
  }

  /**
   * Sends a notification email after updating the email or phone number.
   * @param type The type of update (primary, recovery, etc.).
   */
  sendMailUpdateNotification(type){
    let pEmailId = sessionStorage.getItem('email'); 
    if(type=='recovery'){
      pEmailId=this.paramEmail
    }
    this.manageProfileService.sendMailUpdateNotification(type, pEmailId, this.newEmail, this.person_id).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: response => {
        console.log('API Response:', response); // Debug log
  
        // Since the email is being sent successfully, treat any non-error response as success
        console.log('email sent successfully');
        // this.showSuccessToastMsg(this.capitalizeFirst(type) + ' email updated successfully. A confirmation email has been sent.');
        console.log('Primary email changed successfully', response);
        this.dialogRef.close({ response: 'success' , type: type, newEmail: this.newEmail, newPhone: this.newPhone });
      },
      error: error => {
        console.error('Error sending email notification:', error);
        this.showFailureToastMsg('Failed to send Email notification for update primary email.');
        // Show error toast
        // this.showToastMessage('Failed to update recovery email. Please try again.', 'error');
      }
    });
  }

  /**
 * Sends a notification email after updating the phone number.
 * @param type The type of update (primary, recovery, etc.).
 */
sendPhoneNumberUpdateNotification(type:string) {
  const pEmailId = this.paramEmail ? this.paramEmail : sessionStorage.getItem('email');
  this.manageProfileService.updateProfileNotification(pEmailId, this.newPhone,type, this.person_id).pipe(take(1), takeUntil(this.destroy$)).subscribe({
    next: response => {
      console.log('API Response:', response); // Debug log

      // Treat any non-error response as success
      console.log('Phone number update notification sent successfully');
      // this.showSuccessToastMsg(this.capitalizeFirst(type) + ' phone number updated successfully. A confirmation email has been sent.');
      console.log('Primary phone number changed successfully', response);
      this.dialogRef.close({ response: 'success', type: type, newEmail: this.newEmail, newPhone: this.newPhone });
    },
    error: error => {
      console.error('Error sending phone number update notification:', error);
      this.showFailureToastMsg('Failed to send notification for updated phone number.');
      // this.showToastMessage('Failed to update phone number. Please try again.', 'error');
    }
  });
}


  /**
   * Capitalizes the first letter of the given string.
   * @param str The string to capitalize.
   * @returns The capitalized string.
   */
  capitalizeFirst(str) {
    return str[0].toUpperCase() + str.slice(1);
  }
  /**
   * Migrates old generic localStorage keys to field-specific keys for backward compatibility
   */
  migrateOldResendData(): void {
    const oldResendCount = this.localstorage.getItem('resendCount');
    const oldResendBlockTime = this.localstorage.getItem('resendBlockTime');
   
    // If old keys exist and new keys don't exist, migrate the data
    if (oldResendCount && !this.localstorage.getItem(this.getResendCountKey())) {
      this.localstorage.setItem(this.getResendCountKey(), oldResendCount);
      this.localstorage.removeItem('resendCount');
    }
   
    if (oldResendBlockTime && !this.localstorage.getItem(this.getResendBlockTimeKey())) {
      this.localstorage.setItem(this.getResendBlockTimeKey(), oldResendBlockTime);
      this.localstorage.removeItem('resendBlockTime');
    }
  }
 
  /**
   * Gets the blocking status for all field types
   * @returns Object with blocking status for each field type
   */
  getAllFieldsBlockingStatus(): any {
    const fieldTypes = [
      { type: 'primaryEmail', countKey: 'emailResendCount', blockKey: 'emailResendBlockTime', label: 'Email' },
      { type: 'recoveryEmail', countKey: 'recoveryEmailResendCount', blockKey: 'recoveryEmailResendBlockTime', label: 'Recovery Email' },
      { type: 'phoneNumber', countKey: 'phoneResendCount', blockKey: 'phoneResendBlockTime', label: 'Phone Number' },
      { type: 'altPhoneNumber', countKey: 'altPhoneResendCount', blockKey: 'altPhoneResendBlockTime', label: 'Alternate Phone Number' }
    ];
 
    const status: any = {};
 
    fieldTypes.forEach(field => {
      const count = parseInt(this.localstorage.getItem(field.countKey) || '0');
      const blockTime = this.localstorage.getItem(field.blockKey);
     
      if (blockTime && count >= this.maxResendCount) {
        const blockTimeDate = new Date(blockTime);
        const currentTime = new Date();
        const diff = Math.abs(currentTime.getTime() - blockTimeDate.getTime());
        const fifteenMins = 15 * 60 * 1000;
       
        if (diff < fifteenMins) {
          const remainingMs = (blockTimeDate.getTime() + fifteenMins) - currentTime.getTime();
          const remainingSeconds = Math.ceil(remainingMs / 1000);
          const minutes = Math.floor(remainingSeconds / 60);
          const seconds = remainingSeconds % 60;
         
          status[field.type] = {
            isBlocked: true,
            attempts: count,
            remainingTime: `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
            remainingSeconds: remainingSeconds,
            label: field.label
          };
        } else {
          status[field.type] = {
            isBlocked: false,
            attempts: 0,
            remainingTime: '00:00',
            remainingSeconds: 0,
            label: field.label
          };
        }
      } else {
        status[field.type] = {
          isBlocked: false,
          attempts: count,
          remainingTime: '00:00',
          remainingSeconds: 0,
          label: field.label
        };
      }
    });
 
    return status;
  }
 
  /**
   * Gets field-specific localStorage key for resend count
   * @returns The localStorage key for resend count based on current field type
   */
  getResendCountKey(): string {
    switch(this.type) {
      case 'primaryEmail': return 'emailResendCount';
      case 'recoveryEmail': return 'recoveryEmailResendCount';
      case 'altPhoneNumber': return 'altPhoneResendCount';
      default: return 'phoneResendCount'; // phoneNumber
    }
  }
 
  /**
   * Checks if the current field type is blocked
   * @returns True if current field is blocked, false otherwise
   */
  isCurrentFieldBlocked(): boolean {
    const resendCount = parseInt(this.localstorage.getItem(this.getResendCountKey()) || '0');
    const resendBlockTime = this.localstorage.getItem(this.getResendBlockTimeKey());
   
    if (resendBlockTime && resendCount >= this.maxResendCount) {
      const blockTime = new Date(resendBlockTime);
      const currentTime = new Date();
      const diff = Math.abs(currentTime.getTime() - blockTime.getTime());
      const lockoutDurationMs = this.otpResendLockoutDuration * 60 * 1000;
     
      return diff < lockoutDurationMs;
    }
   
    return false;
  }
 
  /**
   * Gets the remaining block time for current field in seconds
   * @returns Remaining seconds or 0 if not blocked
   */
  getCurrentFieldRemainingTime(): number {
    const resendCount = parseInt(this.localstorage.getItem(this.getResendCountKey()) || '0');
    const resendBlockTime = this.localstorage.getItem(this.getResendBlockTimeKey());
   
    if (resendBlockTime && resendCount >= this.maxResendCount) {
      const blockTime = new Date(resendBlockTime);
      const currentTime = new Date();
      const lockoutDurationMs = this.otpResendLockoutDuration * 60 * 1000;
      const remainingMs = (blockTime.getTime() + lockoutDurationMs) - currentTime.getTime();
     
      if (remainingMs > 0) {
        return Math.ceil(remainingMs / 1000);
      }
    }
   
    return 0;
  }

  /**
   * Gets the current field's resend count
   * @returns Current field resend count
   */
  getCurrentFieldResendCount(): number {
    return parseInt(this.localstorage.getItem(this.getResendCountKey()) || '0');
  }

  /**
   * Checks if current field has reached max resend count
   * @returns True if max resends reached
   */
  isCurrentFieldMaxResendsReached(): boolean {
    return this.getCurrentFieldResendCount() >= this.maxResendCount;
  }

  /**
   * Gets current field resend block time display
   * @returns Formatted time string for current field
   */
  getCurrentFieldBlockTimeDisplay(): string {
    const remainingTime = this.getCurrentFieldRemainingTime();
    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
 
  /**
   * Gets field-specific localStorage key for resend block time
   * @returns The localStorage key for resend block time based on current field type
   */
  getResendBlockTimeKey(): string {
    switch(this.type) {
      case 'primaryEmail': return 'emailResendBlockTime';
      case 'recoveryEmail': return 'recoveryEmailResendBlockTime';
      case 'altPhoneNumber': return 'altPhoneResendBlockTime';
      default: return 'phoneResendBlockTime'; // phoneNumber
    }
  }
 
  /**
   * Debug method to log all field blocking statuses (for testing)
   * Call this method from browser console to check field statuses
   */
  logAllFieldsStatus(): void {
    const allStatus = this.getAllFieldsBlockingStatus();
    console.log('=== FIELD BLOCKING STATUS ===');
   
    Object.keys(allStatus).forEach(fieldType => {
      const status = allStatus[fieldType];
      console.log(`${status.label} (${fieldType}):`);
      console.log(`  - Blocked: ${status.isBlocked}`);
      console.log(`  - Attempts: ${status.attempts}/${this.maxResendCount}`);
      console.log(`  - Remaining Time: ${status.remainingTime}`);
      console.log('---');
    });
   
    console.log('Current Field:', this.type);
    console.log('Current Field Blocked:', this.isCurrentFieldBlocked());
    console.log('Current Field Remaining Time:', this.getCurrentFieldRemainingTime(), 'seconds');
  }
 
  /**
   * Getter property for email send verification button disabled state
   */
  get isEmailSendButtonDisabled(): boolean {
    return !this.newEmail || 
           this.newEmail === this.oldEmail || 
           this.invalidEmail || 
           this.emailTooLong || 
           this.isBlocked || 
           this.isCheckingEmail || 
           this.isPrimaryAndRecoverySameEmail || 
           this.emailAlredyExist;
  }

  /**
   * Getter property for phone send verification button disabled state
   */
  get isPhoneSendButtonDisabled(): boolean {
    return !this.newPhone || 
           this.newPhone === this.oldPhone || 
           this.invalidPhone || 
           this.isBlocked || 
           this.isCheckingPhone || 
           this.emailAlredyExist || 
           this.phoneEmpty ||
           this.sameNumber;
  }

  /**
   * Getter property for OTP verify button disabled state
   */
  get isOtpVerifyButtonDisabled(): boolean {
    return (this.otp.join('')).length < 6 || 
           this.timerActive || 
           this.isCurrentFieldMaxResendsReached() || 
           this.getCurrentFieldRemainingTime() > 0;
  }

  /**
   * Getter property for OTP resend button disabled state
   */
  get isOtpResendButtonDisabled(): boolean {
    return this.timerActive || 
           this.isCurrentFieldMaxResendsReached() || 
           this.getCurrentFieldRemainingTime() > 0;
  }

  get invalidEmailFormate(): boolean {

    if(this.newEmail==='' && this.fieldFocus){
       this.errorMessage = this.errorMessages['M0014']
       return true
    }else if(this.invalidEmail && this.newEmail!=='' && !this.emailTooLong){
      this.errorMessage = this.errorMessages['M0015']
      return true
    }else if(this.sameEmail && this.type==='primaryEmail'){
      this.errorMessage = this.errorMessages['M0085']
      return true
    }else if(this.sameEmail && this.type==='recoveryEmail'){
      this.errorMessage = this.errorMessages['M0086']
      return true
    }else if(this.isPrimaryAndRecoverySameEmail){
      this.errorMessage =  this.errorMessages['M0088']
      return true
    }

    return false;

  }

  get invalidPhoneNumberFormate(): boolean{

    if(this.fieldFocus && this.phoneEmpty){
      this.errorMessage = this.errorMessages['M0016']
      return true
    }else if(this.invalidPhone && !this.phoneEmpty){
      this.errorMessage = this.errorMessages['M0017']
      return true
    }else if(this.sameNumber){
      this.errorMessage =  this.errorMessages['M0087']
      return true
    }

  }

  /**
   * Cleans phone number by removing formatting characters, preserving country code if present
   * @param phoneNumber The phone number to clean (e.g., "+1 (983) 457 9400" or "(234) 253 2478")
   * @returns The cleaned phone number with only digits (e.g., "19834579400" or "2342532478")
   */
  cleanPhoneNumber(phoneNumber: string): string {
    if (!phoneNumber) return '';
   
    // Remove all non-digit characters and return the digits
    // Remove all non-digit characters, then strip leading country code 1 if 11 digits
    const cleaned = phoneNumber.replace(/\D/g, '').replace(/^1(\d{10})$/, '$1');;
   
    return cleaned;
  }


  // Configuration-driven input field validation
  private fieldConfigs = {
    phone: {
      allowedKeys: ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'],
      allowNumbers: true,
      allowSpecialChars: ['+'],
      pasteValidator: /^[\d+\s\-\(\)]*$/,
      inputHandler: (target: HTMLInputElement, value: string, _index?: number, event?: InputEvent) => {
        this.validatePhone(target, value, event?.inputType);
      }
    },
    email: {
      allowedKeys: ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'],
      allowNumbers: true,
      allowSpecialChars: ['@', '.', '_', '-', '%'],
      allowLetters: true,
      pasteValidator: /^[a-zA-Z0-9@._%-]*$/,
      inputHandler: (target: HTMLInputElement, value: string) => {
        this.validateEmail(value);
      }
    },
    otp: {
      allowedKeys: ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'],
      allowNumbers: true,
      allowSpecialChars: [],
      allowLetters: false,
      pasteValidator: /^\d*$/,
      inputHandler: (target: HTMLInputElement, value: string, index?: number) => {
        if (index !== undefined) {
          this.onOtpChange(index, { target } as any);
        }
      }
    }
  };

onOtpBlur(): void {
    this.fieldFocus = false;
    if (this.otpTouched && this.otp.join('').length === 0) {
      this.showOtpErrorMessage();
      this.cdr.detectChanges(); // Ensure UI updates
    } else if (this.otp.join('').length > 0) {
      this.showOtpError = false;
      this.errorMessage = '';
      this.cdr.detectChanges(); // Ensure UI updates
    }
  }


  setShortToastTimer() {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
    this.toastTimer = setTimeout(() => {
      this.showToast = false;
    }, 4000); 
    
  }

  showFailureToastMsg(msg: string){
    this.toastTitle = '';
    this.toastMessageText = msg;
    this.toastType = 'error';
    this.showToast = true;
    this.setShortToastTimer();
    window.scrollTo(0,0);
  }

  showSuccessToastMsg(msg: string){
    this.toastTitle = '';
    this.toastMessageText = msg;
    this.toastType = 'success';
    this.showToast = true;
    this.setShortToastTimer();
    window.scrollTo(0,0);
  }

  /**
   * Loads OTP validation rules from business rules API
   */
  private loadOtpValidationRules() {
    // Fetch maximum OTP attempts
    this.manageProfileService.getBusinessRuleByKey('Security', 'otp_verification_attempt_limit')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.maxAttempts = response.data.data.intValue;
          }
        },
        error: (error) => {
          console.error('Error fetching maximum OTP attempts rule:', error);
        }
      });

    // Fetch maximum OTP resend count
    this.manageProfileService.getBusinessRuleByKey('Security', 'otp_resend_attempt_limit')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.maxResendCount = response.data.data.intValue;
          }
        },
        error: (error) => {
          console.error('Error fetching maximum OTP resend count rule:', error);
        }
      });

    // Fetch OTP lockout duration
    this.manageProfileService.getBusinessRuleByKey('Security', 'verify_button_lock_duration')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.otpLockoutDuration = response.data.data.intValue;
          }
        },
        error: (error) => {
          console.error('Error fetching OTP lockout duration rule:', error);
        }
      });

    // Fetch OTP resend short disable duration (for normal resend button disable)
    this.manageProfileService.getBusinessRuleByKey('Security', 'resend_code_short_disable_duration')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.otpResendCooldown = response.data.data.intValue;
            // Update resend timer (value is already in seconds)
            this.resendTimer = this.otpResendCooldown;
          }
        },
        error: (error) => {
          console.error('Error fetching OTP resend short disable duration rule:', error);
        }
      });

    // Fetch OTP resend long lockout duration (after max attempts reached)
    this.manageProfileService.getBusinessRuleByKey('Security', 'resend_code_lock_duration')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.otpResendLockoutDuration = response.data.data.intValue;
          }
        },
        error: (error) => {
          console.error('Error fetching OTP resend long lockout duration rule:', error);
        }
      });
  }

  /**
   * Announces "Close button" for screen readers on mouse hover or focus
   */
  announceCloseButton(): void {
    // Clear first to force re-announcement
    this.hoverAnnouncement = '';
    setTimeout(() => {
      this.hoverAnnouncement = 'Close button';
    }, 50);
  }

  /**
   * Clears the hover announcement
   */
  clearAnnouncement(): void {
    this.hoverAnnouncement = '';
  }

  
  /**
   * Angular lifecycle hook. Cleans up resources and resets fields on destroy.
   */
  ngOnDestroy(): void {
    this.showSecond=false;
    this.clearTimer();
    this.clearResendBlockTimer();
    this.displayPhone = '';
    this.newEmail = '';
    this.newPhone = '';
    this.destroy$.next();
    this.destroy$.complete()
  }

  syncEmailToAzure(currentEmail: string, newEmail: string): void {
    const payload = {
      currentEmail: currentEmail,
      newEmail: newEmail
    };

    this.manageProfileService.syncEmailToAzure(payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          // Response is typically undefined, but email is synced in Azure
          console.log('Email sync request sent to Azure - Response:', response === undefined ? 'undefined (expected)' : response);
        },
        error: (error: any) => {
          // Log error but don't show to user as primary email is already updated
          console.error('Azure sync background error (non-blocking):', error?.message || error);
        }
      });
  }

}
